<div class="alertList">
    <alert-item *ngFor="let a of alertList" [alert]="a"></alert-item>
</div>